export const ERRORS = {
  couldNotUpdateIssueBody: 'Could not update issue body',
}
